"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var logger_1 = tslib_1.__importDefault(require("../utils/logger"));
var event_1 = tslib_1.__importDefault(require("../utils/event"));
var MtQueue = /** @class */ (function (_super) {
    tslib_1.__extends(MtQueue, _super);
    function MtQueue(transport, config, metaData) {
        var _this = _super.call(this) || this;
        _this.transport = transport;
        _this.config = config;
        _this.metaData = metaData;
        return _this;
    }
    MtQueue.prototype.add = function (log) {
        // 合并 metadata 中的环境信息
        var info = this.metaData.getInfo();
        log.tags = log.tags
            ? tslib_1.__assign(tslib_1.__assign({}, info), log.tags) : info;
        this.transport.send(log).catch(function (err) {
            logger_1.default.log('通过babel 上报异常', err);
        });
    };
    return MtQueue;
}(event_1.default));
exports.default = MtQueue;
//# sourceMappingURL=mtQueue.js.map